export var InternalFeature;
(function (InternalFeature) {
    InternalFeature["Vaults"] = "vaults";
    InternalFeature["Localization"] = "localization";
})(InternalFeature || (InternalFeature = {}));
